import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import Image from 'components/Basic/Image/Image';
import { useFooterSetting } from 'connectors/footerSetting/footerSetting';
import useTranslation from 'next-translate/useTranslation';

const FooterBigIcons: FC = () => {
    const { t } = useTranslation();
    const footerSetting = useFooterSetting();

    if (footerSetting === null) {
        return null;
    }

    const logoSection = footerSetting.logoSection;

    if (logoSection.length === 0) {
        return null;
    }

    return (
        <div className="hidden vl:mt-5 vl:flex vl:justify-end vl:pb-4">
            {logoSection.map((item, index) => (
                <ExtendedNextLink
                    key={index}
                    className="relative ml-7 flex h-[70px] w-36 content-center items-center first:ml-0"
                    href={item.url}
                    target="_blank"
                >
                    <Image fill alt={t('Icon')} src={item.mainImage?.url ?? null} />
                </ExtendedNextLink>
            ))}
        </div>
    );
};

export default FooterBigIcons;
